




























































import Header from '@/components/nav/BackNav.vue'; // dialog
import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Button, Table, TableColumn, Scrollbar, Loading, Message,
} from 'element-ui';
import TopBack from '@/components/nav/Index.vue'; // nav
import NProgress from 'nprogress';
import Read from '@/servers/modules/vocabulary/read'; // server
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';

Vue.use(Loading.directive);
    @Component({
      components: {
        TopBack,
        Table,
        TableColumn,
        Scrollbar,
        Button,
        Header,
      },
    })
export default class extends Vue {
        private isNewImg = require('@/assets/images/new.png');

        // @ts-ignore
        @Mutation public setSkeletonDescribe;

        // @ts-ignore
        @Mutation public setNavData;

        private navData: any;

        // @ts-ignore
        @Getter public changeCourse: any;

        private loading: boolean = false;

        private data: any = {};

        private tableDataImg:any={
          1: require('@/assets/images/ui-word/rank1.png'),
          2: require('@/assets/images/ui-word/rank2.png'),
          3: require('@/assets/images/ui-word/rank3.png'),
        };

        private tableHeaderClassName() {
          return 'table-header';
        }

        private tableRowClassName() {
          return 'table-row';
        }

        private tableData:any = [];

        private gameData:any = [];

        private async init(id:any) {
          this.loading = true;
          this.getGameHomePageInfo({
            courseId: window.LS.get('vteData').course.courseId,
            userId: window.LS.get('vteData').user.userId,
            gameId: id,
          }).then((res) => {
            if (res.data.data.allScoreSort) {
              res.data.data.allScoreSort.myMaxScore = res.data.data.myMaxScore;
              this.data = res.data.data.allScoreSort;
              const data = res.data.data.allScoreSort.gameStatisticsList;
              if (data) {
                for (let i = 0; i < data.length; i++) {
                  data[i].order = (i + 1);
                }
                this.tableData = data;
              }
            }
            this.operat = id;
            this.loading = false;
          });
        }

        private created() {
          this.navData = window.LS.get('basicData').courseName;
          this.setSkeletonDescribe(true);
          NProgress.start();
          // title
          this.title = '';// window.LS.get('vteData').course.courseTitle;
          this.init(this.$route.query.gameId);
          this.gameList({
            courseId: window.LS.get('vteData').course.courseId,
            userId: window.LS.get('vteData').user.userId,
            userCourseId: window.LS.get('vteData').userCourseId,
          }).then((res: any) => {
            NProgress.done();
            this.setSkeletonDescribe(false);
            this.loading = false;
            const nav:any = res.data.data;
            for (let i:number = 0; i < nav.length; i++) {
              nav[i].game.isShow = false;
              if (nav[i].game.name == '神速邮差') {
                nav[i].game.isShow = true;
              }
              if (nav[i].game.name == '射击高手') {
                nav[i].game.isShow = true;
              }
              if (nav[i].game.name == '单词连连看') {
                nav[i].game.isShow = true;
              }
              this.operat = this.$route.query.gameId;
            }
            // 设置导航导航
            this.changeOperat = nav;
          });
        }

        private async getGameHomePageInfo(para: any) {
          // const para = {
          //     courseId: window.LS.get('vteData').course.id,
          //     gameId: this.$route.query.gameId && this.$route.query.gameId,
          //     userId: window.LS.get('basicData').userID,
          // }
          return await Read.getGameHomePageInfo(para);
        }

        // 查询游戏列表
        private async gameList(para: any) {
          return await Read.gameList(para);
        }

        // tab 切换
        private operat: string = '0';

        // 表格 TableColumn 名字
        private changeOperat : any[] = [
          // {id:'1',isShow:true,name:'神速邮差'},
          // {id:'2',isShow:true,name:'射击高手'},
          // {id:'1',isShow:false,name:'拼写高手'},
          // {id:'4',isShow:true,name:'单词连连看'},
          // {id:'1',isShow:false,name:'拼字游戏'},
          // {id:'1',isShow:false,name:'词汇接龙'},
          // {id:'1',isShow:false,name:'听辨高手'},
          // {id:'1',isShow:false,name:'例句达人(体验版)'},
        ];

        private operation(operat) {
          this.tableData = [];
          this.init(operat);
        }

        // 切换课程 - 同步切换本地所有的缓存内容
        private async goReadDetail(data) {

          const loading = Loading.service({ text: '切换中' });
          const form:any = { gradeId: data.gradeID };
          if (data.userGradeExtId) form.userGradeExtId = data.userGradeExtId;
          const res = await changeCourse.changeCourse(form);
          if (res.data) {
            let path: string = null;
            let nav: string = null;
            if (res.data.data && res.data.data.gradeType === 'word') {
              path = '/vocabulary';
              nav = 'vet';
            }
            // 阅读跳到阅读
            if (res.data.data && res.data.data.gradeType === 'read') {
              path = '/read';
              nav = 'read';
            }
            // 决胜跳到决胜
            if (res.data.data && res.data.data.gradeType === 'jse') {
              path = '/decisive';
              nav = 'jse';
            }
            // 保存 只能到达的模块路由类型
            res.data.data.modelType = path;
            res.data.data.courseId = res.data.data.refID;

            res.data.data.token = res.config.headers.Authorization;


            // 存储基本数据
            window.LS.set('basicData', res.data.data);
            // 设置导航栏 及相关的属性
            this.setNavData(nav);
            loading.close();
            // 回到相关的页面的首页
            this.$router.push(path);
            Message({ message: '切换成功', type: 'success' });
          }
        }
}
